import { graphql } from '@/generated/gql';

export const CMDI_META_COLUMN_CONFIG_QUERY = graphql(/* GraphQL */ `
  query CmdiMetaColumnConfig($id: uuid!) {
    cmdi {
      meta_columnConfig(where: { entityId: { _eq: $id } }) {
        id
        columnName
        options
        variant
        i18n
      }
    }
  }
`);
